import { FC } from "react";

interface DropOffIconProps {
  className?: string;
}

const DropOffIcon: FC<DropOffIconProps> = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="10" fill="#00A042" />
        <g clipPath="url(#clip0_14626_75804)">
          <path
            d="M9.99882 16.0988C9.46851 16.0988 10.0959 15.2614 7.48147 13.959C7.33824 13.8875 7.19924 13.8078 7.06518 13.7204C5.76435 12.874 4.96094 11.3261 4.96094 9.65984C4.96094 6.91924 7.21632 4.69727 9.99882 4.69727C12.7813 4.69727 15.0367 6.91924 15.0367 9.65931C15.0367 11.4952 14.0588 13.1895 12.5204 13.9569C9.90336 15.2609 10.5291 16.0988 9.99882 16.0988ZM9.99882 11.6495C11.1183 11.6495 12.014 10.7629 12.014 9.68477C12.014 8.60666 11.1183 7.71999 9.99882 7.71999C8.87935 7.71999 7.98366 8.60666 7.98366 9.68477C7.98366 10.7629 8.87935 11.6495 9.99882 11.6495Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_14626_75804">
            <rect
              width="12.7273"
              height="12.7273"
              fill="white"
              transform="translate(3.63672 3.63672)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default DropOffIcon;
